<template>
  <BasePayment
    :loading="loading"
    :textHeader="$t('apps.payment.label.payserviceusagemonthly')"
    :steps="progress.steps"
    :active="progress.active"
    :showBackButton="isShowBackButton"
  >
    <Paid
      v-if="isChargeSuccess"
      :transaction="transaction"
      @next="onPaidClickedNext"
    />
    <PaymentFail
      v-else
      @next="onPaymentFailClickedNext"
    />
  </BasePayment>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LocalStorage from 'store'
import StepProgress from '@/components/custom/StepProgress.vue'
import Paid from './Paid.vue'
import PaymentFail from './PaymentFail.vue'

export default {
  components: {
    StepProgress,
    Paid,
    PaymentFail,
  },

  data () {
    return {
      loading: false,
      progress: {
        steps: [
          this.$t('apps.payment.message.progressstep1'),
          this.$t('apps.payment.message.progressstep2'),
          this.$t('apps.payment.message.progressstep3'),
        ],
        active: 1,
      },
      tabConfirm: {
        isSubmitted: false,
      },
      isChargeSuccess: false,
      timer: null,
    }
  },

  computed: {
    ...mapState('billing', {
      transaction: 'transactionSingle',
    }),
    isStepOne () {
      return this.progress.active === 0
    },
    isStepTwo () {
      return this.progress.active === 1
    },
    isStepThree () {
      return this.progress.active === 3
    },
    isShowBackButton () {
      return (this.isStepOne || this.isStepTwo) && !this.loading
    },
  },

  mounted () {
    const chargeId = LocalStorage.get('chargeId')
    if (!chargeId) {
      return this.$router.push({ name: 'Home' })
    }

    this.loading = true
    this.setState()

    this.fetchCharge()
    this.timer = setInterval(() => {
      if (!this.isChargeSuccess) {
        this.fetchCharge()
      }
    }, 2000)
  },

  destroyed () {
    clearInterval(this.timer)
  },

  methods: {
    ...mapActions('billing', {
      getTransactionBy: 'getTransactionBy',
    }),
    setState () {
      this.$store.dispatch('setSection', 'login')
      this.setTabTitle(this.$t('apps.payment.label.payserviceusagemonthly'))
    },
    async fetchCharge () {
      const done = () => {
        clearInterval(this.timer)
        LocalStorage.remove('chargeId')
        this.loading = false
      }
      const chargeId = LocalStorage.get('chargeId')
      const response = await this.getTransactionBy({ chargeId })
      if (response.data.charge.status === 'successful' && response.data.transaction) {
        done()
        this.isChargeSuccess = true
        this.progress.active = 2
      } else if (['failed'].includes(response.data.charge.status)) {
        done()
        this.isChargeSuccess = false
      }
    },
    onPaidClickedNext () {
      this.$router.push({ name: 'Home' })
    },
    onPaymentFailClickedNext () {
      this.$router.push({ name: 'Home' })
    },
  },
}
</script>

<style scoped>
.main {
  margin-top: 50px;
}

.text-header {
  font-size: 22px;
}

.custom-step-progress {
  max-width: 600px;
  margin: 30px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/paymentpackage/CallbackAuth.vue